import styled from 'styled-components';
import { PrimaryButton } from '../../shared/sharedStyles.styles';

export default styled(PrimaryButton)`
  font-size: 12px;
  font-weight: 600;
  width: auto;
  min-width: auto;
  height: auto;
  padding: 9px 20px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff !important;
  background: ${({$onBlue}) => (
    $onBlue
      ? `linear-gradient(
          165deg,
          #ffc56b 0%,
          #ff9f2e 18%,
          #ff7200 45%,
          #e85d00 72%,
          #c44a00 100%
        )`
      : `linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)`
  )} !important;
  box-shadow: ${({$onBlue}) => (
    $onBlue
      ? `0 2px 8px rgba(255, 114, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25)`
      : `0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25)`
  )};
  transition: filter 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

  @media (max-width: 800px) {
    width: auto;
    height: auto;
    font-size: 12px;
  }

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.12) !important;
    filter: brightness(1.05);
    box-shadow: ${({$onBlue}) => (
      $onBlue
        ? `0 4px 14px rgba(255, 114, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)`
        : `0 1px 0 rgba(255, 255, 255, 0.15) inset, 0 4px 14px rgba(21, 43, 78, 0.35)`
    )};
    transform: translateY(-1px);
    background: ${({$onBlue}) => (
      $onBlue
        ? `linear-gradient(
            165deg,
            #ffc56b 0%,
            #ff9f2e 18%,
            #ff7200 45%,
            #e85d00 72%,
            #c44a00 100%
          )`
        : `linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)`
    )} !important;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PDFButton = styled(PrimaryButton)`
  font-size: 12px;
  font-weight: 500;
  width: auto;
  min-width: 5vw;
  height: auto;
  padding: .2vw;
  margin-bottom: 10px;
  margin-right: 5px;
  background: #ffffff !important;
  border: 1px solid #152b4e !important;
  border-radius: 10px;
  color: #152b4e !important;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  &:hover {
    background: #f8fafc !important;
    border: 1px solid #152b4e !important;
    color: #152b4e !important;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ButtonEndWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 2;
`;

export const RequestButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  position: fixed;
  right: 20px;
  bottom: 30px;
  font-size: .8rem;
  margin-top: .5rem;
  z-index: 1;
  width: 45px;
  height: 45px;
  border-radius: 45px;

  ${({customstyle}) => customstyle}
`;
